import styled from 'styled-components';

const Container = styled.div`
  padding: 12px 20px;
  font-size: 16px;
`;

export default Container;
